(function () {
  const collapsibleContainer = document.querySelector("#accordion");
  if (!collapsibleContainer) return;

  initCollapsible();

  function initCollapsible() {
    const children = Array.from(collapsibleChildren());
    children.forEach(child => {
      child.addEventListener("click", (event) => {
        event.preventDefault();
        const isHidden = child.getAttribute("aria-expanded") === "false";
        hideChildren(children);
        if (isHidden) {
          showChild(child);
        }
      });
    });
    if (children.length === 0) return;
    const firstChild = children[0];
    showChild(firstChild);
    hideChildren(children.slice(1));
  }

  function collapsibleChildren() {
    return collapsibleContainer.querySelectorAll("[data-role='collapsible']");
  }

  function hideChildren(children) {
    children.forEach(child => {
      child.setAttribute("aria-expanded", "false");
      child.classList.remove("active");
      const span = child.querySelector("span");
      if (span) {
        span.classList.remove("minus");
        span.classList.add("plus");
      }
      const sibling = child.nextElementSibling;
      if (sibling && sibling.classList.contains("swlink")) {
        sibling.style.display = "none";
      }
    });
  }

  function showChild(child) {
    child.setAttribute("aria-expanded", "true");
    child.classList.add("active");
    const span = child.querySelector("span");
    if (span) {
      span.classList.remove("plus");
      span.classList.add("minus");
    }
    const sibling = child.nextElementSibling;
    if (sibling && sibling.classList.contains("swlink")) {
      sibling.style.display = null;
    }
  }
})();
